import compareReducer from './compare';
import contentCardsReducer from './contentCards';
import dealerCodesReducer from './dealerCodes';
import franchiseListReducer from './franchiseList';
import layoutReducer from './layout';
import modalSettingsReducer from './modalSettings';
import offSiteDataReducer from './offSiteData';
import userProfileReducer from './userProfile';
import widgetInfoReducer from './widgetInfo';

export default {
	compareVehicles: compareReducer,
	contentCards: contentCardsReducer,
	dealerCodes: dealerCodesReducer,
	franchiseList: franchiseListReducer,
	layout: layoutReducer,
	modalSettings: modalSettingsReducer,
	offSiteData: offSiteDataReducer,
	userProfile: userProfileReducer,
	widgetInfo: widgetInfoReducer
};
